/*
 * As conversas com o bot pelo recurso JSON:API `canela-ai-conversations`
 * (com as mensagens, `canela-ai-messages`, só como inclusão).
 *
 * A página e a barra lateral trabalham com objetos simples (AiConversation,
 * AiMessage), e não com modelos do `app.store`: a resposta em streaming do bot
 * manda a conversa e as mensagens nesse mesmo formato, linha a linha, e as
 * duas origens se misturam na mesma lista. Aqui os documentos JSON:API viram
 * esses objetos.
 */
import app from 'flarum/forum/app';
const TYPE = 'canela-ai-conversations';
function url(path = '') {
  return `${app.forum.attribute('apiUrl')}/${TYPE}${path}`;
}
function toConversation(resource) {
  const attributes = resource.attributes;
  return {
    id: resource.id,
    title: attributes.title ?? null,
    persona: attributes.persona ?? null,
    messageCount: attributes.messageCount ?? 0,
    createdAt: attributes.createdAt ?? null,
    updatedAt: attributes.updatedAt ?? null
  };
}
function toMessage(resource) {
  const attributes = resource.attributes;
  return {
    id: resource.id,
    role: attributes.role,
    content: attributes.content ?? '',
    tools: attributes.tools ?? [],
    model: attributes.model ?? null,
    createdAt: attributes.createdAt ?? null
  };
}

/** Uma página da lista (50 por vez); `hasMore` vem do `links.next`. */
export function fetchConversations(offset) {
  return app.request({
    method: 'GET',
    url: url(),
    params: {
      page: {
        offset
      }
    }
  }).then(document => ({
    data: document.data.map(toConversation),
    hasMore: !!document.links?.next
  }));
}

/** A conversa e as mensagens, na ordem em que o servidor as relaciona. */
export function fetchConversation(id) {
  return app.request({
    method: 'GET',
    url: url(`/${id}`)
  }).then(document => {
    const included = new Map((document.included ?? []).map(resource => [`${resource.type}:${resource.id}`, resource]));
    const linkage = document.data.relationships?.messages?.data;
    const messages = (Array.isArray(linkage) ? linkage : []).map(ref => included.get(`${ref.type}:${ref.id}`)).filter(resource => !!resource).map(toMessage);
    return {
      conversation: toConversation(document.data),
      messages
    };
  });
}
export function renameConversation(id, title) {
  return app.request({
    method: 'PATCH',
    url: url(`/${id}`),
    body: {
      data: {
        type: TYPE,
        id,
        attributes: {
          title
        }
      }
    }
  }).then(document => toConversation(document.data));
}
export function deleteConversation(id) {
  return app.request({
    method: 'DELETE',
    url: url(`/${id}`)
  });
}
flarum.reg.add('ramon-canela', 'forum/features/ai/bot/api', { fetchConversations: fetchConversations,fetchConversation: fetchConversation,renameConversation: renameConversation,deleteConversation: deleteConversation, });